import { hotList } from '@/mocks/homeMock';

const rankBadge = (rank: number) =>
  rank === 1 ? 'bg-primary-500 text-background-50'
    : rank === 2 ? 'bg-accent-500 text-foreground-950'
      : rank === 3 ? 'bg-secondary-500 text-background-50'
        : 'bg-background-200 text-foreground-700';

export default function HotRank() {
  return (
    <section id="hot" className="mx-auto max-w-7xl scroll-mt-24 px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-3 py-1 text-xs font-semibold text-primary-600">
            <i className="ri-fire-line" />
            HOT RANKING
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">今日全网热度榜</h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">按热度与首发速度综合排序，实时刷新，抢先前排一目了然。</p>
        </div>
        <div className="flex items-center gap-2 text-xs text-foreground-600">
          <span className="inline-block h-2 w-2 rounded-full bg-primary-500" />
          <span>榜单每 5 分钟自动更新</span>
        </div>
      </div>

      <div className="mt-8 grid gap-3">
        {hotList.map((h) => (
          <article
            key={h.rank}
            className="group flex items-center gap-4 rounded-2xl border border-background-200 bg-background-50 p-3 transition hover:border-primary-200 hover:bg-background-100 md:gap-5 md:p-4"
          >
            <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-base font-black ${rankBadge(h.rank)}`}>
              {h.rank}
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <a href="#topics" className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-800">
                  {h.tag}
                </a>
                <span className="text-xs text-foreground-400">{h.time}</span>
              </div>
              <h3 className="mt-1.5 truncate text-sm font-bold text-foreground-900 transition group-hover:text-primary-600 md:text-base">
                {h.title}
              </h3>
            </div>
            <div className="hidden shrink-0 flex-col items-end gap-1 lg:flex">
              <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-2.5 py-1 text-xs font-semibold text-primary-600">
                <i className="ri-time-line" />
                首发 · {h.firstSource}
              </span>
              <span className="text-xs text-foreground-500">领先全网 {h.leadMin} 分钟</span>
            </div>
            <div className="flex shrink-0 flex-col items-end">
              <div className="flex items-baseline gap-1">
                <span className="text-xs text-foreground-500">热度</span>
                <span className="font-heading text-xl font-black text-primary-500 md:text-2xl">{h.heat}</span>
              </div>
              <span className={`text-xs ${h.delta.includes('+') ? 'text-accent-600' : 'text-foreground-500'}`}>{h.delta}</span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}